/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$1({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends({}, rest, _ext[baseName] || {});
};

var normalize = {
  push: function push(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  back: function back(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  go: function go(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  replace: function replace(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  reLaunch: function reLaunch(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  },
  switchTab: function switchTab(api, containerName) {
    return function (options) {
      return promisify(api)(styleIn(options, containerName));
    };
  }
};

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

var go$6 = normalize.go(function (options) {
  var step = options.step,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  if (step < 0) {
    my.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.ALIPAY);

var back$b = normalize.back(function (options) {
  var _ref = options || {},
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  my.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);
var back$c = back$b;

var reLaunch$6 = normalize.reLaunch(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  my.reLaunch({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);

var replace$6 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  my.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);

var push$b = normalize.push(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  my.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);
var push$c = push$b;

var switchTab$6 = normalize.switchTab(function (options) {
  my.switchTab(options);
}, CONTAINER_NAME.ALIPAY);

var aliMiniAppModule = {
  push: push$c,
  back: back$c,
  reLaunch: reLaunch$6,
  switchTab: switchTab$6,
  replace: replace$6,
  go: go$6
};

var go$5 = normalize.go(function (options) {
  var step = options.step,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  if (step < 0) {
    wx.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.WECHAT);

var back$9 = normalize.back(function (options) {
  var _ref = options || {},
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  wx.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);
var back$a = back$9;

var reLaunch$5 = normalize.reLaunch(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  wx.reLaunch({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);

var replace$5 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  wx.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);

var push$9 = normalize.push(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  wx.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.WECHAT);
var push$a = push$9;

var switchTab$5 = normalize.switchTab(function (options) {
  wx.switchTab(options);
}, CONTAINER_NAME.WECHAT);

var weChatModule = {
  push: push$a,
  back: back$a,
  reLaunch: reLaunch$5,
  switchTab: switchTab$5,
  replace: replace$5,
  go: go$5
};

var go$4 = normalize.go(function (options) {
  var step = options.step,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  if (step < 0) {
    tt.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.BYTE);

var back$7 = normalize.back(function (options) {
  var _ref = options || {},
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  tt.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);
var back$8 = back$7;

var reLaunch$4 = normalize.reLaunch(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  tt.reLaunch({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);

var replace$4 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  tt.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);

var push$7 = normalize.push(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  tt.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);
var push$8 = push$7;

var switchTab$4 = normalize.switchTab(function (options) {
  tt.switchTab(options);
}, CONTAINER_NAME.BYTE);

var bytedanceModule = {
  push: push$8,
  back: back$8,
  reLaunch: reLaunch$4,
  switchTab: switchTab$4,
  replace: replace$4,
  go: go$4
};

var go$3 = normalize.go(function (options) {
  var step = options.step,
      success = options.success,
      fail = options.fail,
      complete = options.complete;

  if (step < 0) {
    setTimeout(function () {
      history.go(options.step);
      success && success();
      complete && complete();
    });
  } else {
    fail && fail({
      errMsg: 'step不能大于或等于0'
    });
    complete && complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.WEB);

var back$5 = normalize.back(function (options) {
  var _ref = options || {},
      success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;

  setTimeout(function () {
    try {
      history.go(-1);
      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
var back$6 = back$5;

var replace$3 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _ref$isHash = _ref.isHash,
      isHash = _ref$isHash === void 0 ? false : _ref$isHash,
      _ref$refresh = _ref.refresh,
      refresh = _ref$refresh === void 0 ? true : _ref$refresh,
      success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;

  var _url = isHash ? "/#" + url : url;

  setTimeout(function () {
    try {
      if ((url.indexOf('https://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
        console.warn('Uni API: Replace does not support cross-domain');
        location.href = url;
        return;
      }

      if (isHash) {
        var _location = location,
            href = _location.href;
        var index = href.indexOf('#'); // 域名不变的情况下不会刷新页面

        window.location.replace(index > 0 ? href.slice(0, index) + "#" + url : href + "#" + url);
      } else {
        window.history.replaceState(null, null, _url);
        refresh && location.reload();
      }

      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);

var reLaunch$3 = normalize.reLaunch(function (options) {
  var url = options.url,
      _options$isHash = options.isHash,
      isHash = _options$isHash === void 0 ? false : _options$isHash,
      _options$refresh = options.refresh,
      refresh = _options$refresh === void 0 ? true : _options$refresh,
      success = options.success,
      fail = options.fail,
      complete = options.complete;

  var _url = isHash ? "/#" + url : url;

  setTimeout(function () {
    try {
      history.go(-(history.length - 1));

      if ((url.indexOf('https://') !== -1 || url.indexOf('https://') !== -1) && url.indexOf(location.origin) === -1) {
        console.warn('Uni API: Relaunch does not support cross-domain');
        location.href = url;
        return;
      }

      if (isHash) {
        replace$3({
          url: url,
          isHash: true
        });
      } else {
        window.history.replaceState(null, null, _url);
        refresh && location.reload();
      }

      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);

var push$5 = normalize.push(function (options) {
  var url = options.url,
      _options$isHash = options.isHash,
      isHash = _options$isHash === void 0 ? false : _options$isHash,
      _options$refresh = options.refresh,
      refresh = _options$refresh === void 0 ? true : _options$refresh,
      success = options.success,
      fail = options.fail,
      complete = options.complete;
  setTimeout(function () {
    try {
      if (isHash) {
        location.hash = "#" + url;
      } else if (refresh) {
        location.href = url;
      } else {
        var state = {
          page_id: 1
        };
        var title = '';
        history.pushState(state, title, url);
      }

      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
var push$6 = push$5;

var switchTab$3 = normalize.switchTab(function () {
  throw new Error('@uni/apis: switchTab 不支持');
}, CONTAINER_NAME.WEB);

var webModule = {
  push: push$6,
  back: back$6,
  reLaunch: reLaunch$3,
  switchTab: switchTab$3,
  replace: replace$3,
  go: go$3
};

var go$2 = normalize.go(function (options) {
  var step = options.step,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  if (step < 0) {
    ks.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.KWAI);

var back$3 = normalize.back(function (options) {
  var _ref = options || {},
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  ks.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);
var back$4 = back$3;

var reLaunch$2 = normalize.reLaunch(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  ks.reLaunch({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);

var replace$2 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  ks.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);

var push$3 = normalize.push(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  ks.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.KWAI);
var push$4 = push$3;

var switchTab$2 = normalize.switchTab(function (options) {
  ks.switchTab(options);
}, CONTAINER_NAME.KWAI);

var kuaiShouModule = {
  push: push$4,
  back: back$4,
  reLaunch: reLaunch$2,
  switchTab: switchTab$2,
  replace: replace$2,
  go: go$2
};

var go$1 = normalize.go(function (options) {
  var step = options.step,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;

  if (step < 0) {
    swan.navigateBack({
      delta: Math.abs(step),
      success: function success() {
        _success && _success();
      },
      fail: function fail(res) {
        _fail && _fail(res);
      },
      complete: function complete(res) {
        _complete && _complete(res);
      }
    });
  } else {
    _fail && _fail({
      errMsg: 'step不能大于或等于0'
    });
    _complete && _complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.BAIDU);

var back$1 = normalize.back(function (options) {
  var _ref = options || {},
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  swan.navigateBack({
    delta: 1,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);
var back$2 = back$1;

var reLaunch$1 = normalize.reLaunch(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  swan.reLaunch({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);

var replace$1 = normalize.replace(function (options) {
  var _ref = options || {},
      url = _ref.url,
      _success = _ref.success,
      _fail = _ref.fail,
      _complete = _ref.complete;

  swan.redirectTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);

var push$1 = normalize.push(function (options) {
  var url = options.url,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  swan.navigateTo({
    url: url,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BAIDU);
var push$2 = push$1;

var switchTab$1 = normalize.switchTab(function (options) {
  swan.switchTab(options);
}, CONTAINER_NAME.BAIDU);

var baiDuModule = {
  push: push$2,
  back: back$2,
  reLaunch: reLaunch$1,
  switchTab: switchTab$1,
  replace: replace$1,
  go: go$1
};

var push = function push(options) {
  if (isWeb) {
    return webModule.push(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.push(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.push(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.push(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.push(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.push(options);
  } else {
    throw new Error('Uni API：navigate.push 暂不支持');
  }
};
var go = function go(options) {
  if (isWeb) {
    return webModule.go(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.go(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.go(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.go(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.go(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.go(options);
  } else {
    throw new Error('Uni API：navigate.go 暂不支持');
  }
};
var back = function back(options) {
  if (isWeb) {
    return webModule.back(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.back(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.back(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.back(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.back(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.back(options);
  } else {
    throw new Error('Uni API：navigate.back 暂不支持');
  }
};
var replace = function replace(options) {
  if (isWeb) {
    return webModule.replace(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.replace(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.replace(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.replace(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.replace(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.replace(options);
  } else {
    throw new Error('Uni API：navigate.replace 暂不支持');
  }
};
var reLaunch = function reLaunch(options) {
  if (isWeb) {
    return webModule.reLaunch(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.reLaunch(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.reLaunch(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.reLaunch(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.reLaunch(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.reLaunch(options);
  } else {
    throw new Error('Uni API：navigate.reLaunch 暂不支持');
  }
};
var switchTab = function switchTab(options) {
  if (isWeb) {
    return webModule.switchTab(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.switchTab(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.switchTab(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.switchTab(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.switchTab(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.switchTab(options);
  } else {
    throw new Error('Uni API：navigate.switchTab 暂不支持');
  }
};
var navigate = {
  push: push,
  back: back,
  reLaunch: reLaunch,
  switchTab: switchTab,
  replace: replace,
  go: go
};

export { back as b, navigate as n, push as p };
